module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-100.woff2?c2aa4ab115bf9c6057cb59709d0e152b";